import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { loginUser } from '../../controllers/user.controller'

function Login() {

  const [loginFields, setLoginFields] = useState({email:"", password:""})

  const navigate =useNavigate()
  function goTo(place){
    navigate(place)
  }

  function sendUserDataToLogin(event) {
    event.preventDefault()
    loginUser(loginFields.email,loginFields.password);
    goTo("/credencial")
  }


  return (
    <div className='fullContainer bg-white d-flex align-items-center justify-content-center'>
        <div className="rounded-5 p-4 bg-white border border-4 border-success d-flex flex-column gap-2">
            <h1 className="dark text-center mb-3">Iniciar sesión</h1>
            <form className="d-flex flex-column gap-3" action="submit">
                <input value={loginFields.email}    onChange={e => setLoginFields({...loginFields,email:e.target.value})} className="input mt-2" type="text" placeholder='Correo Electrónico'/>
                <input value={loginFields.password} onChange={e => setLoginFields({...loginFields,password:e.target.value})} className="input mb-2" type="password" placeholder="Contraseña" />
                <div className="text-center">
                    <button onClick={sendUserDataToLogin} className="yellowBtn ">Entrar</button>
                </div>
            </form>
            <p className="darkMediun mt-4 click" onClick={() => goTo("/registrarme")}>No tengo un usuario, deseo Registrarme</p>
        </div>
    </div>
  )
}

export default Login